import {
    generateConstructFromFilterColumns,
} from '../../components/GenericFilterComponent/GenericFilterComponentUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { COMBINEMODE, generateObjectWithCriteriaMode, getCombined } from '../../sagas/util';

const ADD_BULK_ITEMS_SEARCH_FILTER_COLUMNS = [
    {
        name: 'drugType',
        label: 'Product Type',
        type: 'select',
        defaultValue: null,
        valueField: 'key',
        options: [
            { key: 'product', value: 'Only Drugs' },
            { key: 'consumable', value: 'Only Non Drugs' },
        ],
        dataSourceConfig: {
            text: 'value',
            value: 'key',
        },
        searchConstructFields: {
            name: 'pt.type',
            filterOperation: '=',
        },
    },
    {
        name: 'quantity',
        label: 'Quantity',
        type: 'fieldWithOperation',
        options: ['<=', '=', '>='],
        valueType: 'number',
        valueLabel: 'Enter Quantity',
        searchConstructFields: {
            name: 'warehouse_qty.warehouse_quantity',
            filterOperation: '<=',
        },
    },
];

export const ADD_BULK_ITEMS_FILTER_SCHEMA = [
    ...ADD_BULK_ITEMS_SEARCH_FILTER_COLUMNS,
    {
        name: 'onlyActive',
        label: 'Only Active',
        type: 'checkbox',
        defaultValue: true,
        disableClear: true,
    },
];

const generateSearchTextConstruct = (searchText) => {
    const trimmed = (searchText || '').trim();
    if (!trimmed) {
        return null;
    }
    const codeCriteria = generateObjectWithCriteriaMode('pp.default_code', trimmed, '=');
    const nameCriteria = generateObjectWithCriteriaMode('pp.name_template', trimmed, '%');
    return getCombined(codeCriteria, COMBINEMODE.OR, nameCriteria);
};

export const generateAddBulkItemsSearchConstruct = (filters) => {
    if (!isObjectValidAndNotEmpty(filters)) {
        return null;
    }

    let searchConstruct = generateSearchTextConstruct(getStringFromObject('searchText', filters, ''));
    const filterConstruct = generateConstructFromFilterColumns(ADD_BULK_ITEMS_SEARCH_FILTER_COLUMNS, filters);
    if (isObjectValidAndNotEmpty(filterConstruct)) {
        searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, filterConstruct);
    }

    const onlyActive = getStringFromObject('onlyActive', filters, true);
    if (onlyActive) {
        const activeCriteria = generateObjectWithCriteriaMode('pp.active', true, '=');
        searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, activeCriteria);
    }

    return isObjectValidAndNotEmpty(searchConstruct) ? searchConstruct : null;
};
